// imageUtils.js
export function convertToPng(file) {
  return new Promise((resolve, reject) => {
    if (!file || !(file.type === "image/jpeg" || file.type === "image/jpg")) {
      resolve(file); // Pas besoin de convertir
      return;
    }
    const img = new window.Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      canvas.toBlob((blob) => {
        if (!blob) return reject(new Error("Conversion PNG échouée"));
        const pngFile = new File([blob], file.name.replace(/\.(jpg|jpeg)$/i, ".png"), { type: "image/png" });
        resolve(pngFile);
      }, "image/png");
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}

//Creators : Franck Douaud @3DDGAMES -- Under license